import React from "react";
const createReactClass = require('create-react-class');

const buttonComponent  = (page,goToPage,activePage) => {
  return (
    <a key={page} onClick={(e) => {goToPage(page)}} className={"paginationBtn btn btn-default btn-sm"+ ((page+1) == activePage ? " active" : "")}>{page+1}</a>
  )
}

export default createReactClass({
  nextButton:function(totalPage){
    var {parent} = this.props;
    var {activePage, pageNumberToShow, startPageNumber,endPageNumber,t} = this.props;

    if(activePage < totalPage){
      if(activePage == endPageNumber){
        startPageNumber = endPageNumber;
        endPageNumber += pageNumberToShow;
      }
      activePage++
    }

    parent.setState({
      startPageNumber: startPageNumber,
      activePage:activePage,
      endPageNumber: endPageNumber
    });
  },
  prevButton:function(totalPage){
    var {parent,activePage,pageNumberToShow,startPageNumber,endPageNumber} = this.props;
    if(activePage > 1){
      activePage --;
      if(activePage == startPageNumber){
        endPageNumber = activePage;
        startPageNumber -= pageNumberToShow;
      }
    }
    parent.setState({
      activePage:activePage,
      endPageNumber: endPageNumber,
      startPageNumber: startPageNumber
    });
  },
  goToPage:function(page){
    this.props.parent.setState({
      activePage:page+1
    })
  },
  goToFirstPage: function(){
    var { pageNumberToShow } = this.props;
    this.props.parent.setState({
      activePage:1,
      startPageNumber:0,
      endPageNumber: pageNumberToShow
    })
  },
  goToLastPage: function(totalPage){
    this.props.parent.setState({
      activePage:totalPage,
      startPageNumber: totalPage-1,
      endPageNumber: totalPage,
    })
  },
  render:function(){
    var { totalPage, pageNumberToShow, activePage, startPageNumber, endPageNumber, t } = this.props;
    var buttons=[];
    if(endPageNumber > totalPage){
      endPageNumber = totalPage;
    }
    for(var i=startPageNumber;i<endPageNumber;i++){
      buttons[i] = buttonComponent(i,(page) => {this.goToPage(page)},activePage);
    }
    return(
      <div className="row">
        <div className="col-md-2">
        </div>
        <div className="col-md-8 paginationDiv">
            <button onClick={() => {this.prevButton(totalPage)}} className="btn btn-default btn-sm"><i className="fa fa-angle-left"></i>{t('previousPage')}</button>
            &nbsp;<a key={"first"} id="costListPageFirstPageButton" onClick={() => {this.goToFirstPage()}} className={"paginationBtn btn btn-default btn-sm"}>{t('first')}</a>
            {buttons}
            <a key={"last"}  id="costListPageLastPageButton" onClick={() => {this.goToLastPage(totalPage)}} className={"paginationBtn btn btn-default btn-sm"}>{t('last')}</a>
           <button onClick={() => {this.nextButton(totalPage)}} className="btn btn-default btn-sm"><i className="fa fa-angle-right"></i> {t('nextPage')}</button>
        </div>
        <div className="col-md-2">
        </div>
      </div>
    );
  }
});
